export const CHECK_TIME_NOT_ACTIVE_KEY = 'CHECK_TIME_NOT_ACTIVE_KEY';
export const TIME_NOT_ACTIVE = 3600000; // set active 1h
